module.exports = __webpack_public_path__ + "static/img/cheese.ae43fd04.webp";